/* @flow */

import arrayFrom from 'array-from';
import history from './HistoryHandler';

const KEY = {
  ESC: 27,
}

class ExhibitionModal {
  constructor() {
    this.setupListeners();
  }

  setupListeners() {
    this.setupHistoryListener();
    this.setupCloseButtonListener();
    this.setupModalTriggersListener();
    this.setupNextButtonsListener();
    this.setupKeyDownListener();
  }

  setupHistoryListener() {
    this.handleModalsWithHistory(history.location);
    history.listen(this.handleModalsWithHistory.bind(this));
  }

  handleModalsWithHistory(location: Object) {
    const id = location.pathname.split('?')[0].slice(1);

    if (id) {
      this.openModal(id);
    } else {
      this.closeModal();
    }
  }

  setupCloseButtonListener() {
    const closeButtons: NodeList<HTMLElement> =
      document.querySelectorAll('.js-exhibition-modal-close');

    arrayFrom(closeButtons).forEach((button: HTMLElement) => {
      button.addEventListener(
        'click',
        this.closeModalWithHistory.bind(this),
        false
      );
    });
  }

  setupModalTriggersListener() {
    const modalTriggers: NodeList<HTMLElement> =
      document.querySelectorAll('[data-modal-target]');

    window.addEventListener('message', event => {
      if ( /^exhibit-id/.test(event.data) ) {
        const targetId = event.data.split('=')[1];
        this.openModalWithHistory(targetId);
      }
    });

    arrayFrom(modalTriggers).forEach((trigger: HTMLElement) => {
      const targetId = trigger.getAttribute('data-modal-target') || '';
      trigger.addEventListener(
        'click',
        (event: Event) => this.openModalWithHistory(targetId, event),
        false
      )
    });
  }

  setupNextButtonsListener() {
    const nextButtons: NodeList<HTMLElement> =
      document.querySelectorAll('.js-exhibition-modal-next');

    arrayFrom(nextButtons).forEach(button => {
      button.addEventListener('click', this.openNextModal.bind(this), false);
    });
  }

  setupKeyDownListener() {
    document.addEventListener('keydown', this.handleKeyDown.bind(this), false);
  }

  closeModal() {
    const modals = document.querySelectorAll('.js-exhibition-modal');
    arrayFrom(modals).forEach(modal => {
      modal.classList.remove('is-open');
      document.body && document.body.classList.remove('u-no-scroll');
    });
  }

  closeModalWithHistory() {
    history.push('/' + history.location.search);
    this.closeModal();
  }

  openModal(targetId: string, event: ?Event) {
    if (event) {
      event.preventDefault();
    }
    const target = document.querySelector(`#${targetId}`);
    this.closeModal();

    if (target) {
      target.classList.add('is-open');
    }
    document.body && document.body.classList.add('u-no-scroll');
  }

  openModalWithHistory(targetId: string, event: ?Event) {
    history.push(targetId + history.location.search);
    this.openModal(targetId, event);
  }

  openNextModal(event: Event) {
    event.preventDefault();
    const currentModal = document.querySelector('.js-exhibition-modal.is-open');

    if (currentModal) {
      const nextModal = currentModal.nextElementSibling;
      currentModal.classList.remove('is-open');

      if (nextModal && nextModal.classList.contains('js-exhibition-modal')) {
        this.openModalWithHistory(nextModal.getAttribute('id') || '')
      } else {
        const firstModal = document.querySelector('.js-exhibition-modal');
        if (firstModal) {
          this.openModalWithHistory(firstModal.getAttribute('id') || '')
        }
      }
    }
  }

  handleKeyDown(event: Event) {
    if (event.keyCode === KEY.ESC) {
      this.closeModalWithHistory();
    }
  }
}

export default ExhibitionModal;
